export default [
    'AED',
    'AED',
    'AED',
    'AED',
    'AED',
    'AED',
    'AED',
    'AED',
    'AED',
    'AED',
    'AED',
    'AED',
    'AED',
    'AED',
    'AED',
    'AED',
    'AED',
    'AED',
    'AED',
    'AED',
    'AED',
    'AED',
    'AFN',
    'AFN',
    'AFN',
    'ALL',
    'ALL',
    'ALL',
    'AMD',
    'AMD',
    'AMD',
    'ARS',
    'ARS',
    'ARS',
    'ARS',
    'ARS',
    'ARS',
    'ARS',
    'ARS',
    'ARS',
    'ARS',
    'ARS',
    'ARS',
    'ARS',
    'ARS',
    'ARS',
    'ARS',
    'ARS',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AUD',
    'AWG',
    'AWG',
    'BAM',
    'BAM',
    'BAM',
    'BBD',
    'BBD',
    'BBD',
    'BBD',
    'BDT',
    'BDT',
    'BDT',
    'BDT',
    'BGN',
    'BGN',
    'BGN',
    'BGN',
    'BGN',
    'BGN',
    'BGN',
    'BHD',
    'BHD',
    'BHD',
    'BHD',
    'BHD',
    'BIF',
    'BIF',
    'BIF',
    'BMD',
    'BMD',
    'BMD',
    'BMD',
    'BMD',
    'BMD',
    'BND',
    'BND',
    'BND',
    'BOB',
    'BOB',
    'BOB',
    'BRL',
    'BRL',
    'BRL',
    'BRL',
    'BRL',
    'BRL',
    'BRL',
    'BRL',
    'BRL',
    'BRL',
    'BRL',
    'BRL',
    'BRL',
    'BRL',
    'BRL',
    'BRL',
    'BRL',
    'BRL',
    'BRL',
    'BRL',
    'BRL',
    'BSD',
    'BSD',
    'BSD',
    'BTN',
    'BTN',
    'BWP',
    'BWP',
    'BWP',
    'BWP',
    'BWP',
    'BZD',
    'BZD',
    'BZD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CAD',
    'CDF',
    'CDF',
    'CDF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CHF',
    'CLP',
    'CLP',
    'CLP',
    'CLP',
    'CLP',
    'CLP',
    'CLP',
    'CLP',
    'CLP',
    'CLP',
    'CLP',
    'CLP',
    'CNH',
    'CNH',
    'CNH',
    'CNH',
    'CNH',
    'CNH',
    'CNH',
    'CNH',
    'CNH',
    'CNH',
    'CNH',
    'CNH',
    'CNH',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'CNY',
    'COP',
    'COP',
    'COP',
    'COP',
    'COP',
    'COP',
    'COP',
    'COP',
    'COP',
    'COP',
    'COP',
    'CRC',
    'CRC',
    'CRC',
    'CUP',
    'CUP',
    'CUP',
    'CVE',
    'CVE',
    'CYP',
    'CZK',
    'CZK',
    'CZK',
    'CZK',
    'CZK',
    'CZK',
    'CZK',
    'CZK',
    'CZK',
    'CZK',
    'CZK',
    'CZK',
    'CZK',
    'CZK',
    'DJF',
    'DJF',
    'DJF',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DKK',
    'DOP',
    'DOP',
    'DOP',
    'DZD',
    'DZD',
    'DZD',
    'EGP',
    'EGP',
    'EGP',
    'EGP',
    'EGP',
    'EGP',
    'ETB',
    'ETB',
    'ETB',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'EUR',
    'FJD',
    'FJD',
    'FJD',
    'FJD',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GBP',
    'GEL',
    'GHS',
    'GHS',
    'GHS',
    'GHS',
    'GMD',
    'GNF',
    'GNF',
    'GNF',
    'GTQ',
    'GTQ',
    'GTQ',
    'GYD',
    'GYD',
    'GYD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HKD',
    'HNL',
    'HNL',
    'HNL',
    'HRK',
    'HRK',
    'HRK',
    'HTG',
    'HTG',
    'HTG',
    'HUF',
    'HUF',
    'HUF',
    'HUF',
    'HUF',
    'HUF',
    'HUF',
    'HUF',
    'HUF',
    'HUF',
    'HUF',
    'IDR',
    'IDR',
    'IDR',
    'IDR',
    'IDR',
    'IDR',
    'IDR',
    'IDR',
    'IDR',
    'IDR',
    'IDR',
    'IDR',
    'IDR',
    'IDR',
    'IDR',
    'IDR',
    'IDR',
    'IDR',
    'ILS',
    'ILS',
    'ILS',
    'ILS',
    'ILS',
    'ILS',
    'ILS',
    'ILS',
    'ILS',
    'ILS',
    'ILS',
    'ILS',
    'ILS',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'INR',
    'IQD',
    'IQD',
    'IQD',
    'ISK',
    'ISK',
    'ISK',
    'ISK',
    'ISK',
    'ISK',
    'ISK',
    'ISK',
    'ISK',
    'JMD',
    'JMD',
    'JMD',
    'JOD',
    'JOD',
    'JOD',
    'JOD',
    'JOD',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'JPY',
    'KES',
    'KES',
    'KES',
    'KES',
    'KHR',
    'KHR',
    'KHR',
    'KMF',
    'KMF',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KRW',
    'KWD',
    'KWD',
    'KWD',
    'KWD',
    'KWD',
    'KWD',
    'KWD',
    'KYD',
    'KYD',
    'KYD',
    'KYD',
    'KYD',
    'KZT',
    'KZT',
    'KZT',
    'LAK',
    'LAK',
    'LAK',
    'LBP',
    'LBP',
    'LBP',
    'LKR',
    'LKR',
    'LKR',
    'LKR',
    'LRD',
    'LRD',
    'LRD',
    'LSL',
    'LSL',
    'LSL',
    'LTL',
    'LYD',
    'LYD',
    'LYD',
    'MAD',
    'MAD',
    'MAD',
    'MAD',
    'MAD',
    'MDL',
    'MDL',
    'MDL',
    'MGA',
    'MGA',
    'MGA',
    'MKD',
    'MKD',
    'MKD',
    'MMK',
    'MMK',
    'MMK',
    'MOP',
    'MOP',
    'MOP',
    'MUR',
    'MUR',
    'MUR',
    'MVR',
    'MVR',
    'MVR',
    'MWK',
    'MWK',
    'MWK',
    'MWK',
    'MXN',
    'MXN',
    'MXN',
    'MXN',
    'MXN',
    'MXN',
    'MXN',
    'MXN',
    'MXN',
    'MXN',
    'MXN',
    'MXN',
    'MXN',
    'MXN',
    'MXN',
    'MXN',
    'MXN',
    'MXN',
    'MXN',
    'MXN',
    'MXN',
    'MXV',
    'MYR',
    'MYR',
    'MYR',
    'MYR',
    'MYR',
    'MYR',
    'MYR',
    'MYR',
    'MYR',
    'MYR',
    'MYR',
    'MYR',
    'MYR',
    'MYR',
    'MYR',
    'MYR',
    'MYR',
    'MYR',
    'MYR',
    'MZN',
    'MZN',
    'NAD',
    'NAD',
    'NAD',
    'NGN',
    'NGN',
    'NGN',
    'NGN',
    'NGN',
    'NIO',
    'NIO',
    'NIO',
    'NOK',
    'NOK',
    'NOK',
    'NOK',
    'NOK',
    'NOK',
    'NOK',
    'NOK',
    'NOK',
    'NOK',
    'NOK',
    'NOK',
    'NOK',
    'NOK',
    'NOK',
    'NOK',
    'NOK',
    'NOK',
    'NOK',
    'NPR',
    'NPR',
    'NPR',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'NZD',
    'OMR',
    'OMR',
    'OMR',
    'OMR',
    'OMR',
    'OMR',
    'PAB',
    'PAB',
    'PAB',
    'PEN',
    'PEN',
    'PEN',
    'PEN',
    'PEN',
    'PEN',
    'PEN',
    'PEN',
    'PEN',
    'PGK',
    'PGK',
    'PGK',
    'PGK',
    'PHP',
    'PHP',
    'PHP',
    'PHP',
    'PHP',
    'PHP',
    'PHP',
    'PHP',
    'PHP',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PKR',
    'PLN',
    'PLN',
    'PLN',
    'PLN',
    'PLN',
    'PLN',
    'PLN',
    'PLN',
    'PLN',
    'PLN',
    'PLN',
    'PLN',
    'PLN',
    'PLN',
    'PLN',
    'PLN',
    'PLN',
    'PLN',
    'PLN',
    'PLN',
    'PLN',
    'PYG',
    'PYG',
    'PYG',
    'QAR',
    'QAR',
    'QAR',
    'QAR',
    'QAR',
    'QAR',
    'RON',
    'RON',
    'RON',
    'RON',
    'RON',
    'RSD',
    'RSD',
    'RSD',
    'RSD',
    'RSD',
    'RSD',
    'RUB',
    'RUB',
    'RUB',
    'RUB',
    'RUB',
    'RUB',
    'RUB',
    'RUB',
    'RUB',
    'RUB',
    'RUB',
    'RUB',
    'RUB',
    'RUB',
    'RWF',
    'RWF',
    'RWF',
    'RWF',
    'SAR',
    'SAR',
    'SAR',
    'SAR',
    'SAR',
    'SAR',
    'SAR',
    'SAR',
    'SAR',
    'SAR',
    'SCR',
    'SCR',
    'SCR',
    'SDG',
    'SDG',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SEK',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SGD',
    'SHP',
    'SLL',
    'SLL',
    'SLL',
    'SOS',
    'SOS',
    'SOS',
    'SVC',
    'SVC',
    'SVC',
    'SZL',
    'SZL',
    'SZL',
    'SZL',
    'SZL',
    'THB',
    'THB',
    'THB',
    'THB',
    'THB',
    'THB',
    'THB',
    'THB',
    'THB',
    'THB',
    'THB',
    'THB',
    'THB',
    'THB',
    'THB',
    'THB',
    'THB',
    'THB',
    'THB',
    'THB',
    'THB',
    'TJS',
    'TJS',
    'TMT',
    'TND',
    'TND',
    'TND',
    'TND',
    'TRY',
    'TRY',
    'TRY',
    'TRY',
    'TRY',
    'TRY',
    'TRY',
    'TRY',
    'TRY',
    'TRY',
    'TRY',
    'TRY',
    'TRY',
    'TRY',
    'TTD',
    'TTD',
    'TTD',
    'TWD',
    'TWD',
    'TWD',
    'TWD',
    'TWD',
    'TWD',
    'TWD',
    'TWD',
    'TWD',
    'TWD',
    'TWD',
    'TWD',
    'TWD',
    'TWD',
    'TWD',
    'TWD',
    'TWD',
    'TWD',
    'TWD',
    'TWD',
    'TWD',
    'TZS',
    'TZS',
    'TZS',
    'TZS',
    'UAH',
    'UAH',
    'UAH',
    'UAH',
    'UGX',
    'UGX',
    'UGX',
    'UGX',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'USD',
    'UYU',
    'UYU',
    'UYU',
    'UZS',
    'UZS',
    'UZS',
    'VND',
    'VND',
    'VND',
    'VND',
    'VND',
    'XAF',
    'XAF',
    'XAF',
    'XAG',
    'XAG',
    'XAG',
    'XAG',
    'XAG',
    'XAG',
    'XAG',
    'XAG',
    'XAG',
    'XAG',
    'XAG',
    'XAG',
    'XAG',
    'XAG',
    'XAG',
    'XAG',
    'XAG',
    'XAU',
    'XAU',
    'XAU',
    'XAU',
    'XAU',
    'XAU',
    'XAU',
    'XAU',
    'XAU',
    'XAU',
    'XAU',
    'XAU',
    'XAU',
    'XAU',
    'XAU',
    'XAU',
    'XAU',
    'XAU',
    'XCD',
    'XDR',
    'XOF',
    'XOF',
    'XPF',
    'XPF',
    'XPF',
    'YER',
    'YER',
    'YER',
    'ZAC',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZAR',
    'ZMW',
    'ZMW',
    'ZMW',
    'ZMW'
];
